<template>
  <div class="link flex align-center justify-center cs" :style="{marginTop: isSwiper?'':'14px'} ">
    <span :style="{'border':isHaveLine?'':'none'}" v-if="isHave">{{text}} >></span>
  </div>
</template>

<script>
export default {
  name: "didlink",
  props: {
    text: {
      type: String,
      default: "了解更多",
    },
    isHave: {
      type: Boolean,
      default: true,
    },
    isSwiper: {
      type: Boolean,
      default: true,
    },
    //是否有下划线
    isHaveLine: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 992px) {
  .link {
    width: auto;
    height: 30px;
    margin: 30px auto 0;

    span {
      height: 30px;
      font-family: Microsoft YaHei-Light, Microsoft YaHei;
      font-weight: 300;

      color: #b4251e;
      line-height: 30px;
      font-size: $font-xl;
      border-bottom: 1PX solid #b4251e;
      padding-bottom: 1px;
    }
  }
}

@media screen and (max-width: 992px) {
  .link {
    width: 160px;
    height: 30px;
    margin: 10px auto 0;

    span {
      height: 30px;
      font-family: Microsoft YaHei-Light, Microsoft YaHei;
      font-weight: 300;

      color: #b4251e;
      line-height: 30px;
      font-size: 24px;
      border-bottom: 1px solid #b4251e;
      padding-bottom: 1px;
    }
  }
}
</style>
